import { render, staticRenderFns } from "./ScrollButton.vue?vue&type=template&id=3d64b339&scoped=true&"
import script from "./ScrollButton.vue?vue&type=script&lang=js&"
export * from "./ScrollButton.vue?vue&type=script&lang=js&"
import style0 from "./ScrollButton.vue?vue&type=style&index=0&id=3d64b339&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d64b339",
  null
  
)

export default component.exports